import React from "react";
import InvoiceGeneratorPage from "./InvoiceGeneratorPage";

/**
 * InvoicePage
 *
 * Invoice Prep — the pre-invoice generation workflow.
 * Displays pending (uninvoiced) job logs and mileage logs ready to be invoiced.
 *
 * Once invoices are generated they move to Posted Invoices (/crm/posted-invoices).
 *
 * Route: /crm/invoices
 */
const InvoicePage = () => {
  return <InvoiceGeneratorPage />;
};

export default InvoicePage;